import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';



export const ModalQuality = (props) => {


	const {
		loading,
		visible,
		method,
		saveCreateCharacteristic,
		saveUpdateCharacteristic,
		setVisible,
		tittleDialog,
		formValues,
		validaciones,
		handleInputChange,
		saveDelete




	} = props;


	// * CONFIGURATION DESING DIALOG
	const dialogTheme = method === "delete"
		? ` seller-dialog seller-dialog seller-danger seller-small-v`
		: "Global-dialog Global-blue Global-medium ";


	const icon = method === "delete"
		? <i className="fa fa-trash"></i>
		: <i className="fa fa-check-square-o"></i>





	return (
		<Dialog
			visible={visible}
			onHide={() => setVisible(false)}
			modal
			closable={false}
			dismissableMask={false}
			header={
				<div className="Global-dialog-header">
					<div className="Global-dialog-header__content">
						<div className="Global-dialog-icon">
							{icon}
						</div>

						<div>
							<div className="Global-dialog-title">
								{tittleDialog}

							</div>
						</div>
					</div>
				</div>
			}
			className={` ${dialogTheme}`}
			maskClassName="custom-total-mask"
			blockScroll={true}
			footer={
				<>
					{
						method === "delete" && <Button
							size="sm"
							color="secondary"
							type="button"
							onClick={saveDelete}
							disabled={loading}
						>
							{loading ? "Eliminando" ?? "--" : "Eliminar" ?? "---"}
						</Button>
					}
					{
						method === "update" && <Button
							size="sm"
							color="secondary"
							type="button"
							onClick={() => saveUpdateCharacteristic()}
							disabled={loading}
						>
							{loading ? "Actualizando" ?? "--" : "Actualizar" ?? "---"}
						</Button>
					}

					{
						method === "create" && <Button
							size="sm"
							type="button"
							color="secondary"
							className="btn-air-light"
							onClick={() => saveCreateCharacteristic()}
							disabled={loading}
						>
							{loading ? "Creando" ?? "--" : "Crear" ?? "---"}
						</Button>
					}
					<Button
						size="sm"
						type="button"
						color="danger"
						className="btn-air-light"
						onClick={() => setVisible(false)}
						disabled={loading}
					>
						{"Cancelar" ?? "---"}
					</Button>
				</>
			}
		>
			{
				method !== "delete" ? (
					<div className="quality-control-form">

						<div className="form-group mb-0">

							<label className="quality-control-label">
								Realize una breve descripción del indicador
								<span className="text-success ml-1">*</span>
							</label>

							<textarea
								className={`form-control quality-control-textarea ${validaciones?.quality_controL ? "is-invalid" : ""}`}
								name="quality_controL"
								value={formValues?.quality_controL ?? ""}
								onChange={handleInputChange}
								rows={6}
								maxLength={1000}
								placeholder="Escribe el motivo o descripción del control de calidad..."
								disabled={loading}
							/>

							<div className="quality-control-counter">
								{formValues?.quality_controL?.length || 0}/1000
							</div>

							{
								validaciones?.quality_controL && (
									<div className="invalid-feedback d-block">
										Ingresa al menos 3 caracteres.
									</div>
								)
							}

						</div>

					</div>
				) : (
					<div className="quality-control-delete">

						<p className="mb-2">
							¿Estás seguro de eliminar este control de calidad?
						</p>

						<div className="quality-control-delete-value">
							{formValues?.quality_controL}
						</div>

					</div>
				)
			}
		</Dialog >
	)
}


